import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { debounceTime } from "rxjs/operators";
import { Subscription } from 'rxjs';

import { Client } from "src/providers/client/client";
import { CustomNavController } from "src/shared/providers/navigation/custom-nav-controller";
import { Loading } from "src/shared/components/loading/loading";
import { AddressModel } from "src/models/address.model";
import { CurrentAddress } from "src/providers/addresses/current-address";
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { AddAddressPage } from 'src/pages/add-address/add-address';
import { WindowService } from "src/shared/providers/window.service";

@Component({
    templateUrl: "addresses.html",
    styleUrls: ["addresses.scss"],
    standalone: false
})
export class AddressesPage implements OnInit {

  addresses: AddressModel[];
  addressResponse: AddressModel[];
  form: UntypedFormGroup;
  isEditPropertiesEnabled = false;
  panelClosedSubscription: Subscription;
  loaded: boolean;
  hasProperties = false;


  boundGoToAddAddress = this.goToAddAddress.bind(this);

constructor(
    private client: Client,
    private fb: UntypedFormBuilder,
    private navCtrl: CustomNavController,
    private currentAddress: CurrentAddress,
    private rightSidePanelService: RightSidePanelService,
    private storage: TidyStorage,
    public windowService: WindowService,
  ) {
    this.panelClosedSubscription = this.rightSidePanelService.afterPanelClosed().subscribe(() => {
      this.getPageData();
    });
    this.form = this.fb.group({
      search: [""],
    });
    this.form.valueChanges
      .pipe(debounceTime(300))
      .subscribe((val) => this.updateSearch(val));
  }

  @Loading("", true)
  async ngOnInit() {
    try {
      this.loaded = false;
      await this.getPageData();
      this.loaded = true;
    } catch (_err) {
      // Silent error handling
    }
  }

  async getPageData() {
    this.addressResponse = await this.client.getMoreDetailAddresses(true);
    this.addresses = this.addressResponse;
  }

  goToAddAddress() {
    this.goToPage('property', {}, AddAddressPage);
  }

  goToEditAddress(address) {
    this.currentAddress.addressId = address.id;
    localStorage.setItem('dashboardAddressId', address.id.toString());
    localStorage.setItem('dashboardAddressName', address.address_name || address.address1);
    this.navCtrl.navigateForward(`properties?propertyId=${address.id}`);
  }

  updateSearch({ search }) {
    if (!search) {
      this.addresses = this.addressResponse;
      return;
    }
    if (search.length < 2) {
      return (this.addresses = this.addressResponse);
    }
    const term = search.toLowerCase();
    this.addresses = this.addressResponse.filter((option) => {
      if (
        option.address1.toLowerCase().indexOf(term) > -1 ||
        option.address_name?.toLowerCase().indexOf(term) > -1
      ) {
        return option;
      }
    });
  }

  onToggleChange(): void {
    this.addresses = this.addressResponse;
    this.form.reset();
    this.isEditPropertiesEnabled = !this.isEditPropertiesEnabled;
  }

  @Loading("", true)
  async updateAddresses(event: any[]): Promise<void> {
    const addressesIds = event.map((address) => address.id);
    try {
      await this.client.saveNewAddressesOrder(addressesIds);
    } catch (_error) {
      // Silent error handling - address reordering failure is not critical
    }
  }

  async goToPage(url, params, component) {
    const isMobileResolution = !this.windowService.isDesktopRes;
    if (!isMobileResolution) {
      const isRightSidePanelAlreadyOpen = await this.storage.retrieve('dialog-right-side-open');
      if (isRightSidePanelAlreadyOpen) {
        this.rightSidePanelService.navigateTo(url, params, component);
      } else {
        this.storage.save('dialog-right-side-open', true);
        this.storage.save('dialog-params', params);
        this.rightSidePanelService.openRightSidePanel(component);
      }
    } else {
      this.navCtrl.navigateForward(url, params);
    }
  }

  goBack() {
    this.navCtrl.navigateBack('more');
  }
}
